import { makeSelectors } from '@utils/css';

const cssTransitionSelectors = makeSelectors({
  isAppearing: "css-transition--is-appearing",
  isEntering: "css-transition--is-entering",
  isExiting: "css-transition--is-exiting"
});

export { cssTransitionSelectors };
//# sourceMappingURL=transition.css.selectors.js.map
